import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
	WorkOutline,
	LabelOutlined,
	LocationOnOutlined,
	MailOutline,
	PermIdentity,
	PhoneAndroid,
} from "@material-ui/icons";
import Avi from "../../img/avi.png";
import Navbar from "../../components/navbar/Navbar";
import "./user.css";
import Preloader from "../../components/preloader/Preloader";
import UpdateForm from "./UpdateForm";
import AdminService from "../../services/admin.service";

export default function User() {
	const { userId } = useParams();
	const [fetching, setFetching] = useState(false);
	const [user, setUser] = useState(null);

	const getUserById = async (id) => {
		setFetching(true);
		let res = await AdminService.getUser(id);
		const data = res.user;
		setUser(data);
		setFetching(false);
	};

	useEffect(() => {
		getUserById(userId);
	}, [userId]);

	const currentUserRoles = (user) => {
		return user.map((role) =>
			role.name === "reviewer"
				? "REVIEWER"
				: role.name === "initiator"
				? "INITIATOR"
				: role.name === "admin"
				? "ADMIN"
				: role.name === "approver"
				? "APPROVER"
				: "USER", 
		);
	};

	return (
		<>
			<Navbar />
			{user && (
				<div className="user">
					<div className="userTitleContainer">
						<h1 className="userTitle">Edit User</h1>
					</div>
					<div className="userContainer">
						<div className="userShow">
							<div className="userShowTop">
								{user.avatar ? (
									<img
										src="https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
										alt=""
										className="userShowImg"
									/>
								) : (
									<img src={Avi} alt="" className="userShowImg" />
								)}
								<div className="userShowTopTitle">
									<span className="userShowUsername">
										{user.firstname} {user.middlename} {user.lastname}
									</span>
								</div>
							</div>
							<div className="userShowBottom">
								<span className="userShowTitle">Staff Details</span>
								<div className="userShowInfo">
									<PermIdentity className="userShowIcon" />
									<span className="userShowInfoTitle">
										{user.firstname} {user.middlename} {user.lastname}
									</span>
								</div>
								<div className="userShowInfo">
									<WorkOutline className="userShowIcon" />
									<span className="userShowInfoTitle userRole">
										{currentUserRoles(user.roles)}
									</span>
								</div>
								<div className="userShowInfo">
									<LabelOutlined className="userShowIcon" />
									<span className="userShowInfoTitle">{user.staffnum}</span>
								</div>
								<div className="userShowInfo">
									<LocationOnOutlined className="userShowIcon" />
									<span className="userShowInfoTitle">{user.employmentLocation}</span>
								</div>
								<span className="userShowTitle">Contact Details</span>
								<div className="userShowInfo">
									<PhoneAndroid className="userShowIcon" />
									<span className="userShowInfoTitle">{user.phone}</span>
								</div>
								<div className="userShowInfo">
									<MailOutline className="userShowIcon" />
									<span className="userShowInfoTitle">{user.email}</span>
								</div>
							</div>
						</div>
						<div className="userUpdate">
							<span className="userUpdateTitle">Edit</span>
							<UpdateForm user={user} userId={userId} setUser={setUser} currentUserRoles={currentUserRoles} />
						</div>
					</div>
				</div>
			)}
			{fetching && <Preloader text={"Fetching data"} />}
		</>
	);
}
